import { Radio } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useMidiContextReader, labelForScope } from '@/lib/midiContext'

/* Header-badge die de actieve MIDI-bezetter toont zodra een MIDI-pagina
   ergens open staat. Klik → naar die pagina toe. Voorkomt "waarom werkt m'n
   LPD8-pad niet"-verrassing wanneer je van Kempenvision naar Image Compo wisselt. */

const HREF = {
  kempenvision: '/kempenvision/midi',
  imagecompo:   '/imagecompo/midi',
  tournaments:  '/tournaments/midi',
  screens:      '/schermregie',
}

/* Twee weergaven:
   - `sidebar` variant: full-width strip onderin sidebar, respecteert collapsed
   - Default: inline pill in mobile-header */
export default function MidiContextBadge({ sidebar, collapsed }) {
  const scope = useMidiContextReader()
  if (!scope) return null
  const href = HREF[scope] || '#'
  const label = labelForScope(scope)
  const title = `MIDI-controller is nu bezet door ${label} — klik om erheen te gaan`

  if (sidebar) {
    return (
      <Link to={href} title={title}
            className="flex items-center gap-2 px-2 py-1.5 rounded-md border border-acid/40 bg-acid/10 text-acid hover:bg-acid/15 transition-colors">
        <Radio className="h-3.5 w-3.5 shrink-0" />
        {!collapsed && (
          <span className="text-[10px] font-mono uppercase tracking-widest truncate">MIDI · {label}</span>
        )}
      </Link>
    )
  }
  return (
    <Link to={href} title={title}
          className="hidden sm:inline-flex items-center gap-1 px-2 py-1 rounded-md border border-acid/40 bg-acid/5 text-acid text-[10px] font-mono uppercase tracking-widest hover:bg-acid/10">
      <Radio className="h-3 w-3" />
      MIDI · {label}
    </Link>
  )
}
